import type {
  SearchEngineEventItem,
  CategoryItem,
} from '~/composables/types/searchEngine'

/**
 * Normalize search engine hit `categories` into a flat array of { name, slug }.
 */
export const categoriesFromSearchEngineHit = (
  hit: Pick<SearchEngineEventItem, 'categories'>
): CategoryItem[] => {
  const raw = hit.categories
  if (!raw) return []
  if (Array.isArray(raw)) return raw
  return (raw as { data?: CategoryItem[] }).data ?? []
}

/**
 * Build a display-name → slug map from event-list search hits so transactional
 * navigation can resolve Strapi `categorySlug` from filter display names.
 */
export const buildCategoryNameToSlugMapFromSearchEngineHits = (
  hits: Pick<SearchEngineEventItem, 'categories'>[]
): Record<string, string> => {
  const map: Record<string, string> = {}
  for (const hit of hits) {
    for (const cat of categoriesFromSearchEngineHit(hit)) {
      if (cat.name && cat.slug) map[cat.name] = cat.slug
    }
  }
  return map
}
